import { useSelector } from "react-redux";
import { IsBbbUseInLessons } from "../../ServiceIntegrations/components/BigBlueButtonIntegrationSettings/hooks/IsBbbUseInLessons";

export const useIsLimitTheTimeForEnteringLesson = () => {
    const limitTheTimeForEnteringLessonStore = useSelector(store => store.settings.limitTheTimeForEnteringLesson);
    const maximumTimeBeforeStartOfLessonStore = useSelector(store => store.settings.maximumTimeBeforeStartOfLesson);
    const isBbbUseInLessons = IsBbbUseInLessons();

    return {
       isLimit :(limitTheTimeForEnteringLessonStore == '1' || isBbbUseInLessons),
       timeLimit: (!!maximumTimeBeforeStartOfLessonStore || maximumTimeBeforeStartOfLessonStore === 0) ? maximumTimeBeforeStartOfLessonStore : 10
    };
}